<div class="modal-window__header">
  <div class="modal-window__title">
    {{ "location.changetitle" | translate }}
  </div>
  <a (click)="onCancel()">
    <i class="c-icon c-icon--close-dark"></i>
  </a>
</div>
<label class="c-form-label">{{ "location.toolsselected" | translate }}</label>
<div
  *ngFor="let tool of location.tools"
  class="modal-window__subtitle">
  {{ tool.toolId }} - {{ tool.modelNumber }}
</div>
<form
  #f="ngForm"
  id="modal-form"
  (ngSubmit)="onMoveLocation()"
  class="o-grid--medium u-mt--medium">
  <div class="c-form-group o-grid__item col-12 col-sm-12">
    <label
      for="locationName"
      class="c-form-label"
      >{{ "location.newlocation" | translate }}</label
    >
    <mat-select
      #locationName="ngModel"
      id="locationName"
      name="locationName"
      [(ngModel)]="location.locationName"
      class="c-user-menu__select c-select c-select--lg"
      [class.is-invalid]="locationName.invalid"
      required>
      <mat-option
        [value]="undefined"
        disabled>
        {{ "location.newlocationplaceholder" | translate }}
      </mat-option>
      <mat-option [value]="null">{{ "location.none" | translate }}</mat-option>
      <mat-option
        [value]="l.locationName"
        *ngFor="let l of locations">
        {{ l.locationName }}: {{ l.locationDescription }}
      </mat-option>
    </mat-select>
  </div>
  <div class="o-grid__item col-offset-6 col-3 u-mt--medium u-tablet">
    <button
      type="button"
      (click)="onCancel()"
      class="button--sm button-secondary button-block">
      {{ "button.cancel" | translate }}
    </button>
  </div>
  <div class="o-grid__item col-12 col-md-3 u-mt--medium">
    <button
      type="submit"
      class="button--sm button-primary button-block"
      [disabled]="f.invalid">
      {{ "button.save" | translate }}
    </button>
  </div>
</form>
